export const isValidPhoneNumber = (value: string): string | boolean => {
  const strippedNumber = value.replace(/[^\d]/g, "");
  return (
    (strippedNumber.length === 10 &&
      !strippedNumber.match(/(\d)\1{9}/) &&
      !strippedNumber.match(/^[01]/)) ||
    "Not a valid phone number"
  );
};
